(() => {
  const protectedSelector = [
    'img',
    'picture',
    'video',
    '.product-media',
    '.product-media-container',
    '.card-gallery',
    '.collection-card__image',
    '.resource-card__media',
    '.home-product-card__media-wrap',
    '.home-category-card__media',
  ].join(',');

  const shield = document.createElement('div');
  shield.className = 'photo-protection-shield';
  shield.setAttribute('aria-hidden', 'true');
  document.documentElement.appendChild(shield);

  let shieldTimer;
  const flashShield = () => {
    window.clearTimeout(shieldTimer);
    shield.classList.add('is-active');
    shieldTimer = window.setTimeout(() => {
      shield.classList.remove('is-active');
    }, 1200);
  };

  const isProtectedTarget = (target) => target instanceof Element && target.closest(protectedSelector);

  const protectImages = (root = document) => {
    root.querySelectorAll?.('img, video').forEach((media) => {
      media.setAttribute('draggable', 'false');
      media.setAttribute('data-photo-protected', 'true');
    });
  };

  protectImages();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches('img, video')) {
          node.setAttribute('draggable', 'false');
          node.setAttribute('data-photo-protected', 'true');
          return;
        }
        protectImages(node);
      });
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener(
    'contextmenu',
    (event) => {
      if (!isProtectedTarget(event.target)) return;
      event.preventDefault();
    },
    { capture: true }
  );

  document.addEventListener(
    'dragstart',
    (event) => {
      if (!isProtectedTarget(event.target)) return;
      event.preventDefault();
    },
    { capture: true }
  );

  document.addEventListener(
    'keydown',
    (event) => {
      const key = event.key.toLowerCase();
      const command = event.metaKey || event.ctrlKey;
      const devtoolsShortcut = command && event.shiftKey && ['i', 'j', 'c'].includes(key);
      const saveOrSourceOrPrint = command && ['s', 'u', 'p'].includes(key);
      const printScreen = key === 'printscreen';
      const f12 = key === 'f12';

      if (!devtoolsShortcut && !saveOrSourceOrPrint && !printScreen && !f12) return;

      flashShield();
      event.preventDefault();
      event.stopPropagation();
    },
    { capture: true }
  );

  document.addEventListener(
    'keyup',
    (event) => {
      if (event.key.toLowerCase() === 'printscreen') {
        flashShield();
      }
    },
    { capture: true }
  );
})();
